import { apiGet } from './client';

function buildQuery(params) {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') return;
    search.set(key, String(value));
  });
  const qs = search.toString();
  return qs ? `?${qs}` : '';
}

export function getScheduleEntries({ query, track_label } = {}) {
  return apiGet(`/me/schedule${buildQuery({ query, track_label })}`);
}

export function getScheduleEntriesNoAuth({ query, track_label } = {}) {
  return apiGet(`/schedule${buildQuery({ query, track_label })}`);
}
